module.exports = __webpack_public_path__ + "static/media/otherCircle.22a0705f.svg";